import { Box, Stack, Tooltip } from "@mui/joy";
import { ReactElement, useMemo } from "react";

import { Route } from "../../core/types";
import { getTraitIcon, getTraitLabel } from "../../utils/traits";

type Props = {
  route: Route;
};

export default function TraitIcons({ route }: Props) {
  const icons = useMemo(() => {
    const result = [] as { icon: ReactElement; label: string }[];
    (["holds", "skills", "styles"] as const).forEach((traitType) => {
      const traitValues = route[traitType];
      traitValues &&
        traitValues.forEach((traitValue) => {
          const TraitIcon = getTraitIcon(traitType, traitValue);
          result.push({
            icon: <TraitIcon key={traitValue} fontSize="lg" />,
            label: getTraitLabel(traitType, traitValue),
          });
        });
    });
    return result;
  }, [route]);
  return (
    <Stack direction="row" gap={0.25}>
      {icons.map(({ icon, label }) => (
        <Tooltip key={label} title={label}>
          <Box>{icon}</Box>
        </Tooltip>
      ))}
    </Stack>
  );
}
